import {CommonModule} from '@angular/common';
import {NavbarAdaptativoComponent, SpinnerComponent} from './components';

export const COMPONENTS = [
  NavbarAdaptativoComponent,
  SpinnerComponent
];

export const IMPORTS = [
  CommonModule
];

export const SERVICES = [];

export const EXPORTS = [
  CommonModule,
  NavbarAdaptativoComponent,
  SpinnerComponent
];
